"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.KnockList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _KnockPropTypes = require("../KnockPropTypes");
var _KnockListItem = require("./KnockListItem");
var _KnockList = require("./KnockList.styled");
var _KnockTypes = require("../../../constants/KnockTypes");
var _utils = require("../../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var KnockList = exports.KnockList = function KnockList(_ref) {
  var isPopoverOpen = _ref.isPopoverOpen,
    _ref$knocks = _ref.knocks,
    knocks = _ref$knocks === void 0 ? [] : _ref$knocks,
    targetElementId = _ref.targetElementId,
    onTogglePopover = _ref.onTogglePopover,
    onApproveAll = _ref.onApproveAll,
    onApprove = _ref.onApprove,
    onDeny = _ref.onDeny,
    trigger = _ref.trigger,
    cameraSources = _ref.unassignedCameraPresenters,
    screenShareSources = _ref.unassignedScreenSharePresenters,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    onAVClicked = _ref.onAVClicked,
    liveCameras = _ref.liveCameras,
    onAssignKnockToSource = _ref.onAssignKnockToSource,
    getItemDisabledState = _ref.getItemDisabledState;
  var headerTitle = 'Speaker requests';

  /** Assigned knocks have a sourceId property */

  var assignedSourceIds = (0, _react.useMemo)(function () {
    return knocks.filter(function (k) {
      return k.sourceId;
    }).map(function (k) {
      return k.sourceId;
    });
  }, [knocks]);
  var getKnockSources = (0, _react.useCallback)(function (knockType) {
    return knockType === _KnockTypes.PRESENTER ? cameraSources : screenShareSources;
  }, [cameraSources, screenShareSources]);

  /**
   * @todo Refactor knockIdToMappedSources & knockIdToAllSources into one function for source of truth for knocks
   */

  /** Create a map of knock id to mapped sources */
  var knockIdToMappedSources = (0, _react.useMemo)(function () {
    return knocks.reduce(function (acc, knock) {
      var currentSources = getKnockSources(knock.type);
      return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, knock._id, currentSources.filter(function (s) {
        var sourceId = s._id;
        var notInitializingState = !!!s.isInitializing;
        var isAssigned = assignedSourceIds.includes(sourceId);
        if (notInitializingState && knock.sourceId === sourceId && isAssigned) {
          return true;
        }
        return notInitializingState && !isAssigned;
      })));
    }, {});
  }, [knocks, assignedSourceIds, getKnockSources]);

  /** Create a map of knock id to ALL available sources */
  var knockIdToAllSources = (0, _react.useMemo)(function () {
    /** A knock should map to one broadcast source a time */
    var matchedSources = [];
    return knocks.reduce(function (acc, knock) {
      var currentSources = getKnockSources(knock.type);
      return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, knock._id, currentSources.filter(function (s) {
        return !matchedSources.includes(s._id);
      }).map(function (source) {
        if ((0, _utils.matchPresenterName)(knock.name, source)) {
          matchedSources.push(source._id);
        }
        return source;
      })));
    }, {});
  }, [knocks, getKnockSources]);
  var handleApproveAll = (0, _react.useCallback)(function () {
    onApproveAll();
    onTogglePopover();
  }, [onApproveAll, onTogglePopover]);
  var handleApproveKnock = function handleApproveKnock(knock) {
    return function (sourceId) {
      return onApprove(_objectSpread(_objectSpread({}, knock), {}, {
        sourceId: sourceId
      }));
    };
  };
  var hasPendingRequests = knocks.length > 0;

  // Popover test with isOpen & trigger don't work together. Adding this for testing purposes
  var popOverProps = trigger ? {
    trigger: trigger
  } : {
    isOpen: isPopoverOpen
  };
  return _react["default"].createElement(_KnockList.KnockListPopover, (0, _extends2["default"])({
    id: "knock-list-popover",
    placement: "bottom",
    target: targetElementId
  }, popOverProps), _react["default"].createElement(_KnockList.KnockListPopoverContainer, null, _react["default"].createElement(_KnockList.KnockListControl, null, _react["default"].createElement(_KnockList.KnockListHeader, null, headerTitle), hasPendingRequests && _react["default"].createElement(_KnockList.KnockListCta, {
    onClick: handleApproveAll,
    "data-testid": 'approve-all-knocks-button',
    color: "light",
    variant: "outlined"
  }, "Approve all")), !hasPendingRequests && _react["default"].createElement(_KnockList.KnockListBody, null, _react["default"].createElement(_KnockList.EmptyKnocks, null, "No requests at this time")), _react["default"].createElement(_KnockList.KnockListBody, null, knocks.map(function (knock) {
    return _react["default"].createElement(_KnockListItem.KnockListItem, {
      key: knock._id,
      knock: knock,
      onApprove: handleApproveKnock(knock)
      // sources are filtered over time as knocks are assigned.
      ,
      sources: knockIdToMappedSources[knock._id]
      // allSources are the sources that were not filtered due to the assigned knock requests.
      ,
      allSources: knockIdToAllSources[knock._id],
      maxCamerasExceeded: maxCamerasExceeded,
      onAVClicked: onAVClicked,
      liveCameras: liveCameras,
      onDeny: onDeny.bind(null, knock),
      onAssignKnockToSource: onAssignKnockToSource(knock),
      isDisabled: getItemDisabledState(knock)
    });
  }))));
};
KnockList.propTypes = {
  isPopoverOpen: _propTypes["default"].bool,
  targetElementId: _propTypes["default"].string,
  knocks: _propTypes["default"].arrayOf(_KnockPropTypes.KnockPropTypes),
  onApproveAll: _propTypes["default"].func,
  onTogglePopover: _propTypes["default"].func,
  onApprove: _propTypes["default"].func,
  onDeny: _propTypes["default"].func,
  trigger: _propTypes["default"].string,
  // Props for testing purposes
  unassignedCameraPresenters: _propTypes["default"].array,
  unassignedScreenSharePresenters: _propTypes["default"].array,
  maxCamerasExceeded: _propTypes["default"].bool,
  onAVClicked: _propTypes["default"].func,
  liveCameras: _propTypes["default"].number,
  onAssignKnockToSource: _propTypes["default"].func,
  assignedScreenSharePresenters: _propTypes["default"].array,
  getItemDisabledState: _propTypes["default"].func
};
var _default = exports["default"] = KnockList;